const priceTooltipContent = `Compare model prices with transaction prices. Click on the value to see the
      distribution of prices for that keyword.
      <div class='tooltip--text-top'><strong>Average listing price</strong> - averaged prices set by designers.</div>
      <div class='row'>
        <div class='col-6 offset-3'>
          <div class='tooltip--bars'>
            <label class='progress-label label-price'>
              <i class='fas fa-arrow-up'></i> $50
            </label>
            <div class='progress'><div class='progress-bar is-default' style='width: 50%'></div></div>
          </div>
          <div class='tooltip--bars'>
            <label class='progress-label label-price'>
              <i class='fas fa-arrow-down'></i> $50
            </label>
            <div class='progress'><div class='progress-bar is-default' style='width: 50%'></div></div>
          </div>
        </div>
      </div>
      <div class='tooltip--text-bottom'><strong>Average sales price</strong> - averaged prices from all purchases
        (prices that are acceptable for buyers)</div>
      <div class='row tooltip--explanation'>
        <div class='col-6'>
          <div class='tooltip--bars tooltip--explanation-bars'>
            <label class='progress-label label-price'>$50</label>
            <div class='progress'><div class='progress-bar is-default' style='width: 50%'></div></div>
          </div>
          <div class='tooltip--bars tooltip--explanation-bars'>
          <label class='progress-label label-price'>$40</label>
          <div class='progress'><div class='progress-bar is-negative' style='width: 40%'></div></div>
          </div>
          Prices are set <strong>too high</strong>, customers prefer lower prices
        </div>
        <div class='col-6'>
          <div class='tooltip--bars tooltip--explanation-bars'>
            <label class='progress-label label-price'>$50</label>
            <div class='progress'><div class='progress-bar is-default' style='width: 50%'></div></div>
          </div>
          <div class='tooltip--bars tooltip--explanation-bars'>
          <label class='progress-label label-price'>$60</label>
          <div class='progress'><div class='progress-bar is-positive' style='width: 60%'></div></div>
          </div>
          Prices are set <strong>too low</strong>, customers agree to pay higher prices or need better quality
        </div>
      </div>
    </div>`

export default priceTooltipContent
